import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { AccountService } from 'src/app/services/user/account.service';
import { GenericModalComponent } from '../../modals/generic-modal/generic-modal.component';
import { UiService } from 'src/app/services/ui.service';
import { ThemeService } from 'src/app/services/client/theme/theme.service';
import { genericError } from 'src/app/models/placeholder';
import { ApiErrorService } from 'src/app/services/api-error.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-inline-generic-error',
  templateUrl: './inline-generic-error.component.html',
  styleUrls: ['./inline-generic-error.component.scss'],
})
export class InlineGenericErrorComponent implements OnInit {
  errorStatus?: any = null;
  image: string;
  retryCount: number;
  partnerPid: string;
  showReloginButton: boolean = false;
  showTryAgainButton: boolean = true;
  private errorStatusSubscription: Subscription;

  constructor(
    private modalController: ModalController,
    private accountService: AccountService,
    private translate: TranslateService,
    private uiService: UiService,
    private theme: ThemeService,
    private apiErrorService: ApiErrorService
  ) {
    this.retryCount = 0;
    this.image = genericError;
  }
  ngOnInit() {
    this.partnerPid = this.theme.getAppPid;

    this.errorStatusSubscription =
      this.apiErrorService.errorStatusValue.subscribe((val) => {
        this.errorStatus = val;
        this.updateErrorActions(val);
      });
  }

  ngOnDestroy() {
    if (this.errorStatusSubscription) {
      this.errorStatusSubscription.unsubscribe();
    }
  }

  reloadCurrentRoute() {
    if (this.uiService.reloadCount > 1) {
      this.uiService.reloadCount = 0;
      this.resetSession();
    }
    this.uiService.reloadCount++;
    this.uiService.reloadPage();
  }

  async resetSession() {
    const modal = await this.modalController.create({
      component: GenericModalComponent,
      componentProps: {
        icon: 'TX_DANGER_ICON',
        message: this.translate.instant(
          'page_status.generic_error.session_has_expired_please_login_again'
        ),
        isPrompt: false,
      },
      showBackdrop: true,
      cssClass: 'generic-modal',
    });
    modal.onDidDismiss().then(() => {
      try {
        this.accountService.logout();
      } catch (error) {
        // console.error('Logout failed:', error);
      }
      window.location.href = '/login';
    });
    return await modal.present();
  }

  goBack(): void {
    this.uiService.reloadPage('/home');
  }
  relogin(): void {
    try {
      this.accountService.logout();
      window.location.href = '/login';
    } catch (error) {
      // console.error('Logout failed:', error);
    }
  }

  private updateErrorActions(status: any): void {
    const normalizedStatus = Number(status);
    this.showReloginButton = [401, 403].includes(normalizedStatus);
    this.showTryAgainButton = !this.showReloginButton;
  }
}
